import { API_SERVER_URL } from 'config';
import { ADMIN_USERNAME } from 'constants/admin';
import { GET_ACCESS_TOKEN, LOGOUT, USER_LOGGED_IN } from 'constants/endpoints';
import { createRequestUrl, defaultOptions, sendRequest } from 'services/utils';

const fetchAuthStatus = async () => {
  const options = defaultOptions('GET');
  const params = { returnUsername: 'true' };
  const request = new Request(
    createRequestUrl(API_SERVER_URL, USER_LOGGED_IN, params),
    options,
  );

  return await sendRequest(request);
};

const fetchToken = async (password) => {
  const options = defaultOptions('POST');
  let formData = new FormData();
  formData.append('username', ADMIN_USERNAME);
  formData.append('password', password);
  options.body = formData;
  const request = new Request(
    createRequestUrl(API_SERVER_URL, GET_ACCESS_TOKEN),
    options,
  );

  return await sendRequest(request);
};

const logout = async () => {
  const options = defaultOptions('GET');
  const request = new Request(
    createRequestUrl(API_SERVER_URL, LOGOUT),
    options,
  );

  await sendRequest(request);
};
export { fetchAuthStatus, fetchToken, logout };
